export interface StreamChunk {
  content?: string
  type: 'chunk' | 'done' | 'error'
  error?: string
}

/** Lee el stream del backend y ejecuta callbacks por cada evento */
export async function readStream(
  response: Response,
  onChunk: (text: string) => void,
  onDone: () => void,
  onError: (error: string) => void
) {
  const reader = response.body?.getReader()
  if (!reader) { onError('No se pudo leer el stream'); return }

  const decoder = new TextDecoder()
  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) { onDone(); break }

      const text = decoder.decode(value, { stream: true })
      
      // El backend manda JSONs pegados sin separador, ej: {"content":"hol","type":"chunk"}{"content":"a","type":"chunk"}
      // Los separamos con regex que encuentra cada objeto JSON
      const jsonRegex = /\{[^}]+\}/g
      const matches = text.match(jsonRegex)

      if (matches) {
        for (const match of matches) {
          try {
            const parsed: StreamChunk = JSON.parse(match)
            if (parsed.type === 'chunk' && parsed.content) onChunk(parsed.content)
            else if (parsed.type === 'done') { onDone(); return }
            else if (parsed.type === 'error') { onError(parsed.error ?? 'Error'); return }
          } catch {
            // Ignorar JSON inválido
          }
        }
      }
    }
  } catch (e) {
    onError(e instanceof Error ? e.message : 'Error leyendo stream')
  }
}
